import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a75c9c72&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a75c9c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75c9c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a75c9c72')) {
      api.createRecord('a75c9c72', component.options)
    } else {
      api.reload('a75c9c72', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a75c9c72&scoped=true&", function () {
      api.rerender('a75c9c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/productEngagement/index.vue"
export default component.exports